const PREPAID_EXPENSES_CODE = 'ASSET.PREPAID_EXPENSES'

/** The server's own rule: the seeded account or a per-currency sibling of it. */
export function isPrepaidExpenseAccount(code: string | undefined): boolean {
  return (
    code !== undefined && (code === PREPAID_EXPENSES_CODE || code.startsWith(`${PREPAID_EXPENSES_CODE}.`))
  )
}
